export default __webpack_public_path__ + "static/media/blank-profile.60023381.png";